import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Grid2, IconButton, MenuItem, Paper, Select, Snackbar, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel, TextField, Typography } from "@mui/material";
import TokenError from "../tokenError";
import config from '../../config/config.js';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import prevIcon from '../../assets/icons/left-arrow.svg';
import nextIcon from '../../assets/icons/right-arrow.svg';
import {makeGetRequestToUrl, makePostRequestToUrl} from '../commonFunc.jsx';
import { Label } from "flowbite-react";
import CloseIcon from '@mui/icons-material/Close';
import InfoIcon from '@mui/icons-material/Info';
import uploadBlue from '../../assets/icons/UploadBlue.svg';
import axios from "axios";

const DriverAnalysis = () => {
    const navigate = useNavigate();
    const [tokenExpired, setTokenExpired] = useState(false);
    const [rows, setRows] = useState([]);
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('request_id');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [planId, setPlanId] = useState(0);
    const [openCancelConfirmModal, setOpenCancelConfirmModal] = useState(false);
    const [recommendedPlanId, setRecommendedPlanId] = useState(0);

      const stats = [
    {
      id: 1,
      title: "Revenue",
      value: "₹ 65,000",
      growth: "+15.03%",
    //   icon: <SportsEsportsIcon />,
      borderColor: "#007BFF",
    },
    {
      id: 2,
      title: "Drivers Subscribed",
      value: "300",
      growth: "+15.03%",
    //   icon: <AccountCircleIcon />,
      borderColor: "#16A34A",
    },
  ];

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
        setCityFilter(e);
    }

    const formatDate = (dateString) => {
        if (!dateString) return '--';
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return '--';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    // Ensure rows is an array and calculate the number of pages safely
    const rowArray = Array.isArray(rows) ? rows : [];
    const totalEntries = rowArray.length;
    const totalPages = Math.ceil(totalEntries / rowsPerPage);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    //sorting
    const handleRequestSort = (property) => {
        const isAscending = orderBy === property && order === 'asc';
        setOrder(isAscending ? 'desc' : 'asc');
        setOrderBy(property);
        const sortedRows = [...rows].sort((a, b) => {
            if (a[property] < b[property]) return isAscending ? -1 : 1;
            if (a[property] > b[property]) return isAscending ? 1 : -1;
            return 0;
        });
        setRows(sortedRows);
    };

    const fetchDriverSubscriptionsreportandanalysis = async() => {
        let recommended=0;
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/analytics/fetch_driver_subscription_analytics';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                city_id: cityFilter,
                // timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
                response.data.forEach(element => {
                    if(element.is_recommend==1 && element.is_active==1){
                        recommended=element.plan_id;
                    }
                });
                setRecommendedPlanId(recommended);
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        fetchDriverSubscriptionsreportandanalysis();
    }, [cityFilter]);



    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };




    const setEnabled = async(id, val) => {
        // console.log('id= ', id, 'and val= ', val);
        try {
            const token = localStorage.getItem('token');
            const body = {
                token: token,
                id:id,
                status:val
            };

            const response = await fetch(operationsUrl + '/driver/update_driver_subscription_analytics', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });
            const data = await response.json();

            if (data.flag==200) {
                fetchDriverSubscriptionsreportandanalysis();
                setMessage(data.message);
                showSnackbar(true);
                setOpenCancelConfirmModal(false);
            }
            else{
                setMessage(data.message);
                showSnackbar(true);
            }
        } catch (error) {
            console.log('An error occurred. Please try again later.');
        }
    }

    return (
        <div>
            {tokenExpired && (<TokenError/>)}
            
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Driver Subscription Report & Analysis
            </Typography>

            {/* Filters */}
            <Grid2 item container spacing={2} alignItems="center" sx={{ marginTop: '1%', marginBottom: '2%' }}>
                <Grid2 item>
                    <Select value={cityFilter} 
                    onChange={(e) => handleCityChange(e.target.value)} displayEmpty
                    style={{width: '190px',height:'46px', marginTop:'0px',borderRadius:'8px',backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_name} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
            </Grid2>

            {false && <Grid2 container spacing={2} alignItems="center" sx={{ marginTop: '1%', marginBottom: '2%' }}>
                <Box>

                <Grid container spacing={2}>
                    {stats.map((item) => (
                    <Grid item xs={12} sm={6} md={6} key={item.id} sx={{minHeight:'200px'}}>
                        <Paper
                        elevation={0}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            p: 2.5,
                            borderRadius: "12px",
                            border: `1.5px solid ${item.borderColor}`,
                        }}
                        >
                        <Avatar
                            sx={{
                            bgcolor: `${item.borderColor}20`,
                            color: item.borderColor,
                            width: 48,
                            height: 48,
                            }}
                        >
                            {item.icon}
                        </Avatar>
                        

                        <Box sx={{ flexGrow: 1 }}>
                            <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: 500, color: "#1A1E25" }}
                            >
                            {item.title}
                            </Typography>
                            <Typography
                            variant="h5"
                            sx={{ fontWeight: 700, color: "#1A1E25" }}
                            >
                            {item.value}
                            </Typography>

                            <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                mt: 0.5,
                                color: "#16A34A",
                                fontSize: "14px",
                                fontWeight: 500,
                            }}
                            >
                            {/* <TrendingUpIcon sx={{ fontSize: 18, mr: 0.5 }} /> */}
                            {item.growth}
                            </Box>
                        </Box>
                        </Paper>
                    </Grid>
                    ))}
                </Grid>
                </Box>
            </Grid2>}

            <TableContainer className="table-container" sx={{maxHeight:'72vh'}}>
                <Table stickyHeader className="scrollable-table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'plan_id'} direction={orderBy === 'plan_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('plan_id')}>
                                Driver ID 
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'plan_id'} direction={orderBy === 'plan_id' ? order : 'asc'}
                                    onClick={() => handleRequestSort('plan_id')}>
                                Plan ID</TableSortLabel></TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'plan_name'} direction={orderBy === 'plan_name' ? order : 'asc'}
                                    onClick={() => handleRequestSort('plan_name')}>
                                Plan Name</TableSortLabel></TableCell>
                            {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Plan Icon</TableCell> */}
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'ride_limit'} direction={orderBy === 'ride_limit' ? order : 'asc'}
                                    onClick={() => handleRequestSort('ride_limit')}>
                                Ride Limit
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'per_ride_max_distance'} direction={orderBy === 'per_ride_max_distance' ? order : 'asc'}
                                    onClick={() => handleRequestSort('per_ride_max_distance')}>
                                Max Distance Per Ride (in km)
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'total_fare_capping'} direction={orderBy === 'total_fare_capping' ? order : 'asc'}
                                    onClick={() => handleRequestSort('total_fare_capping')}>
                                Max Fare
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'start_date'} direction={orderBy === 'start_date' ? order : 'asc'}
                                    onClick={() => handleRequestSort('start_date')}>
                                Start Date
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'end_date'} direction={orderBy === 'end_date' ? order : 'asc'}
                                    onClick={() => handleRequestSort('end_date')}>
                                End Date
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'validity'} direction={orderBy === 'validity' ? order : 'asc'}
                                    onClick={() => handleRequestSort('validity')}>
                                Validity
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'price'} direction={orderBy === 'price' ? order : 'asc'}
                                    onClick={() => handleRequestSort('price')}>
                                Price
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>
                                <TableSortLabel active={orderBy === 'tax_percentage'} direction={orderBy === 'tax_percentage' ? order : 'asc'}
                                    onClick={() => handleRequestSort('tax_percentage')}>
                                Tax Percentage
                                </TableSortLabel>
                            </TableCell>
                            <TableCell align="center" className="table-header" style={{ width: '15%', minWidth:'200px' }}>
                                <TableSortLabel active={orderBy === 't_n_c'} direction={orderBy === 't_n_c' ? order : 'asc'}
                                    onClick={() => handleRequestSort('t_n_c')}>
                                Terms and Conditions
                                </TableSortLabel>
                            </TableCell>
                            {/* <TableCell align="center" className="table-header" style={{ width: '15%' }}>Status</TableCell> */}
                            <TableCell align="center" className="table-header" style={{ width: '15%' }}>Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.length === 0 && (
                            <TableRow>
                            <TableCell colSpan={24} align="center">
                                <Typography variant="body1">No data found</Typography>
                            </TableCell>
                            </TableRow>
                        )}
                        {rows
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => (
                            <TableRow key={row.plan_id}>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.driver_id}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.plan_id}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.plan_name}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.ride_limit}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.per_ride_max_distance}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.total_fare_capping}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{formatDate(row.start_date)}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{formatDate(row.end_date)}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.validity_days == 1 ? '1 day ' : `${row.validity_days} days `}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.price}</Typography></TableCell>
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.tax_percentage}</Typography></TableCell>
                                {/* <TableCell align="center">
                                    {Array.isArray(row.plan_benifits) ? (
                                        <ul style={{ margin: 0, paddingLeft: 16, textAlign: 'center' }}>
                                            {row.plan_benifits.map((b, i, arr) => (
                                                <>
                                                    <li key={`benefit-${i}`} style={{ listStyleType: 'disc', marginTop:'4px' }}>{b}</li>
                                                    {i < arr.length - 1 && (
                                                        <hr style={{border: 'none', borderTop: '2px dotted #D1D5DB'}} />
                                                    )}
                                                </>
                                            ))}
                                        </ul>
                                    ) : row.plan_benifits ? (
                                        <ul style={{ margin: 0, paddingLeft: 16, textAlign: 'center' }}>
                                            {String(row.plan_benifits).split(',').map((b, i, arr) => (
                                                <>
                                                    <li key={`benefit-str-${i}`} style={{ listStyleType: 'disc', marginTop:'4px' }}>{b.trim()}</li>
                                                    {i < arr.length - 1 && (
                                                        <hr style={{border: 'none', borderTop: '2px dotted #D1D5DB'}} />
                                                    )}
                                                </>
                                            ))}
                                        </ul>
                                    ) : (
                                        <Typography sx={{ width: 'auto', minWidth: '100px' }}>--</Typography>
                                    )}
                                </TableCell> */}
                                {/* <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px', color:row.is_recommend==1?'green':'#9E9E9E' }}>{row.is_recommend==1?'Yes':'No'}</Typography></TableCell> */}
                                <TableCell align="center"><Typography sx={{ width: 'auto', minWidth: '100px' }}>{row.t_n_c}</Typography></TableCell>
                                <TableCell align="center">
                                    <Grid2 sx={{display:'flex'}}>

                                        {false &&<Button sx={{border:'1px solid  rgb(31, 93, 199)', width:'90px',borderRadius: '8px', minWidth:'40px', boxShadow:'none', marginLeft:'8px', color:'rgb(31, 93, 199)',
                                            '&:hover': {backgroundColor: 'rgb(31, 93, 199)', color: 'white'},
                                            '&:active': { backgroundColor: 'rgb(31, 93, 199)', color: 'white'}
                                            }}  onClick={() => setEnabled(row.id,4)}

                                        >
                                            Pause
                                        </Button>}
                                        {false &&<Button sx={{border:'1px solid rgb(31, 199, 101)', width:'90px',borderRadius: '8px', minWidth:'40px', boxShadow:'none', marginLeft:'8px', color:'rgb(31, 199, 101)',
                                            '&:hover': {backgroundColor: 'rgb(31, 199, 101)', color: 'white'},
                                            '&:active': { backgroundColor: 'rgb(31, 199, 101)', color: 'white'}
                                            }}  onClick={() => setEnabled(row.id, 0)}
                                        >
                                            Resume 
                                        </Button>}
                                        <Button sx={{
                                            border: `1px solid ${row.status === 5 ? '#757575' : '#C71F1F'}`,
                                            width: '90px',
                                            borderRadius: '8px',
                                            minWidth: '40px',
                                            boxShadow: 'none',
                                            marginLeft: '8px',
                                            color: row.status === 5 ? '#757575' : '#C71F1F',
                                            '&:hover': {
                                                backgroundColor: row.status === 5 ? 'transparent' : '#C71F1F',
                                                color: row.status === 5 ? '#757575' : 'white'
                                            },
                                            '&:active': {
                                                backgroundColor: row.status === 5 ? 'transparent' : '#C71F1F',
                                                color: row.status === 5 ? '#757575' : 'white'
                                            },
                                            '&.Mui-disabled': {
                                                borderColor: '#757575',
                                                color: '#757575'
                                            }
                                        }} 
                                            onClick={() => {
                                                setOpenCancelConfirmModal(true);
                                                setPlanId(row.id);
                                            }}
                                            disabled={row.status === 5}
                                        >
                                            <Typography sx={{textTransform:'none'}}>{row.status === 5 ? 'Cancelled' : 'Cancel'}</Typography>
                                        </Button>
                                    </Grid2>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>

                <div className="custom-pagination">
                    <div className="pagination-info">
                        {`Showing ${page * rowsPerPage + 1} to ${Math.min(
                            (page + 1) * rowsPerPage,
                            rows.length
                        )} of ${rows.length} entries`}
                    </div>
                    <div className="pagination-controls">
                    <button
                        onClick={() => handleChangePage(null, page - 1)}
                        disabled={page === 0}
                        className="pagination-arrow"
                    >
                        <img src={prevIcon} alt="Previous" />
                    </button>
                        <div className="pagination-numbers">
                            {[...Array(Math.ceil(rows.length / rowsPerPage))].map((_, index) => (
                                <button key={index} onClick={() => handleChangePage(null, index)}
                                    className={`pagination-number ${ page === index ? 'active' : ''}`}>
                                    {index + 1}
                                </button>
                            ))}
                        </div>
                        <button
                            onClick={() => handleChangePage(null, page + 1)}
                            disabled={page >= Math.ceil(rows.length / rowsPerPage) - 1}
                            className="pagination-arrow"
                        >
                            <img src={nextIcon} alt="Next" />
                        </button>
                    </div>
                </div>
            </TableContainer>

            <Dialog
                open={openCancelConfirmModal}
                onClose={() => setOpenCancelConfirmModal(false)}
                aria-labelledby="cancel-booking-dialog-title"
                aria-describedby="cancel-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="cancel-booking-dialog-title" sx={{fontWeight:'bold'}}>Confirm Cancelation</DialogTitle>
                <DialogContent>
                    <DialogContentText id="cancel-booking-dialog-description">
                        Are you sure you want to cancel this subscription plan?
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                    <Button 
                        onClick={() => setOpenCancelConfirmModal(false)} 
                        sx={{
                            color: '#6B7280', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            border: '1px solid #D1D5DB',
                            '&:hover': {
                                backgroundColor: '#F3F4F6',
                                borderColor: '#9CA3AF'
                            }
                        }}
                    >
                        No
                    </Button>
                    <Button 
                        onClick={() => {
                            setEnabled(planId,5);
                            setOpenCancelConfirmModal(false);
                        }} 
                        color="error"
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#EF4444', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#DC2626'
                            }
                        }}
                        autoFocus
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
        </div>
    )
}

export default DriverAnalysis;